import { defineMessages } from 'react-intl';

export default defineMessages({
  userCategoryMenuItemDistributor: {
    defaultMessage: 'Distributor',
    id: 'userCategory.menuItem.distributor',
  },
  userCategoryMenuItemHomeOwner: {
    defaultMessage: 'Home owner',
    id: 'userCategory.menuItem.homeOwner',
  },
  userCategoryMenuItemIT: {
    defaultMessage: 'IT',
    id: 'userCategory.menuItem.IT',
  },
  userCategoryMenuItemOther: {
    defaultMessage: 'Other',
    id: 'userCategory.menuItem.other',
  },
  userCategoryMenuItemPropertyManager: {
    defaultMessage: 'Property or facility manager',
    id: 'userCategory.menuItem.propertyManager',
  },
  userCategoryMenuItemSecurity: {
    defaultMessage: 'Security manager',
    id: 'userCategory.menuItem.security',
  },
  userCategoryMenuItemServices: {
    defaultMessage: 'Services (e.g., concierge, receptionist)',
    id: 'userCategory.menuItem.services',
  },
  userCategoryMenuItemSystemIntegrator: {
    defaultMessage: 'System integrator',
    id: 'userCategory.menuItem.systemIntegrator',
  },
});
